import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.7 1.271a.98.98 0 0 0-1.4 0L10 10.363 7.7 8.114a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.369l3 2.933c.2.195.5.293.7.293s.5-.098.7-.293l10-9.776a.93.93 0 0 0 0-1.369M19 8.799c-.6 0-1 .39-1 .977v6.843c0 .587-.4.978-1 .978H3c-.6 0-1-.391-1-.978V2.933c0-.586.4-.977 1-.977h11c.6 0 1-.392 1-.978C15 .391 14.6 0 14 0H3C1.3 0 0 1.271 0 2.933v13.686c0 1.662 1.3 2.933 3 2.933h14c1.7 0 3-1.27 3-2.933V9.776c0-.586-.4-.977-1-.977"
    }, null, -1)
  ]))]))
}
export default { render: render }